var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 34C28.9706 34 33 29.9706 33 25C33 20.0294 28.9706 16 24 16C19.0294 16 15 20.0294 15 25C15 29.9706 19.0294 34 24 34ZM24 20.25C24.4142 20.25 24.75 20.5858 24.75 21V25C24.75 25.4142 24.4142 25.75 24 25.75C23.5858 25.75 23.25 25.4142 23.25 25V21C23.25 20.5858 23.5858 20.25 24 20.25Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.25 14C21.25 13.5858 21.5858 13.25 22 13.25H26C26.4142 13.25 26.75 13.5858 26.75 14C26.75 14.4142 26.4142 14.75 26 14.75H22C21.5858 14.75 21.25 14.4142 21.25 14Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchcircle);
export default __webpack_public_path__ + "static/media/watchcircle.040d01df4dabaf9a54019ba24d62387b.svg";
export { ForwardRef as ReactComponent };